'use client'

import VimeoPlayer from 'react-player/vimeo'
import HgAspectRatio from '~/design-system/hg/components/HgAspectRatio'

export type HgVimeoEmbedProps = {
  url: string
}

export const HgVimeoEmbed = ({url}: HgVimeoEmbedProps) => (
  <HgAspectRatio classNames={{assetWrapper: 'rounded-none'}} aspectRatio="16:9">
    <VimeoPlayer
      data-chromatic="ignore"
      config={{
        playerOptions: {controls: true},
      }}
      url={url}
      width="100%"
      height="100%"
    />
  </HgAspectRatio>
)
